import { useState } from "react";
import { Button } from "antd";
import { EditOutlined } from "@ant-design/icons";

type EditMenuProps = {
  handleChange: Function;
  handleSubmit: Function;
};

const EditGIMenu = ({ handleChange, handleSubmit }: EditMenuProps) => {
  const [isEditing, setIsEditing] = useState<boolean>(false);

  const onSubmit = () => {
    if (isEditing) {
      setIsEditing(false);
      handleChange(false);
      handleSubmit();
    } else {
      setIsEditing(true);
      handleChange(true);
    }
  };

  const onCancel = () => {
    setIsEditing(false);
    handleChange(false);
  };

  return (
    <div className="w-32 pt-6" style={{ position: "sticky", top: "3.5rem" }}>
      <div className="float-menu">
        <div className="flex flex-col gap-4">
          <div>
            <Button
              style={{ height: "2.2rem" }}
              block
              type="primary"
              size="large"
              icon={<EditOutlined />}
              onClick={() => onSubmit()}
            >
              {isEditing ? "Publish" : "Edit"}
            </Button>
          </div>
          <div>
            {isEditing && (
              <Button
                style={{ height: "2.2rem" }}
                block
                shape="round"
                size="large"
                onClick={() => onCancel()}
              >
                {isEditing ? "Cancel" : "Go Back"}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditGIMenu;
